module.exports = __webpack_public_path__ + "img/management.860d382f.png";